import SocialNetworksLinks from './SocialNetworksLinks';

export default SocialNetworksLinks;
